/* SPLENDIDO — scelta colore Etui nel carrello · 2026-08-09
   -------------------------------------------------------------------------
   Salva la scelta come attributo del carrello (`Etui-Farbe`) e aggiorna
   subito l'aspetto, senza ridisegnare il cassetto.

   Ascolto in delega su `document`: il cassetto viene sostituito da Prestige a
   ogni `cart:refresh` (replaceChildren), quindi un listener attaccato ai
   pallini sparirebbe al primo aggiornamento. Lo stato invece lo ridisegna
   Liquid, che legge `cart.attributes`.

   Scelta facoltativa: „Zurücksetzen" rimanda una stringa vuota, e Shopify
   toglie l'attributo dall'ordine — non resta scritto „nessuna preferenza". */
(function () {
  'use strict';
  if (window.__spEtuiInit) return;
  window.__spEtuiInit = true;

  function salva(valore, contenitore, nomeVisibile) {
    /* stato ottimistico: il cliente vede subito il cerchietto acceso */
    disegna(contenitore, valore, nomeVisibile);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Etui-Farbe': valore } })
    }).catch(function () {
      /* se la rete cade rimettiamo quello che dice il carrello vero */
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        disegna(contenitore, (c.attributes && c.attributes['Etui-Farbe']) || '', nomeVisibile);
      });
    });
  }

  function disegna(contenitore, valore, nomeVisibile) {
    var pallini = contenitore.querySelectorAll('[data-sp-etui-valore]');
    for (var i = 0; i < pallini.length; i++) {
      var sel = pallini[i].getAttribute('data-sp-etui-valore') === valore && valore !== '';
      pallini[i].classList.toggle('sp-etui__sw--sel', sel);
      pallini[i].setAttribute('aria-pressed', sel ? 'true' : 'false');
    }
    var reset = contenitore.querySelector('[data-sp-etui-reset]');
    var scelto = contenitore.querySelector('[data-sp-etui-scelto]');
    if (reset) reset.hidden = !valore;
    if (scelto) {
      if (valore) {
        /* il modello della frase arriva da Liquid col segnaposto %%NAME%%:
           qui dentro non c'e' nessun testo da tradurre */
        var modello = scelto.getAttribute('data-sp-modello') || '%%NAME%%';
        /* nome tradotto: lo prendiamo dall'aria-label del pallino, non dal valore tedesco */
        scelto.textContent = modello.replace('%%NAME%%', nomeVisibile || valore.split(' (')[0]);
        scelto.hidden = false;
      } else {
        scelto.hidden = true;
      }
    }
  }

  document.addEventListener('click', function (e) {
    var pallino = e.target.closest && e.target.closest('[data-sp-etui-valore]');
    var reset = e.target.closest && e.target.closest('[data-sp-etui-reset]');
    if (!pallino && !reset) return;
    var contenitore = (pallino || reset).closest('[data-sp-etui]');
    if (!contenitore) return;
    e.preventDefault();
    if (reset) { salva('', contenitore); return; }
    /* ripremere lo stesso colore lo toglie: nessuna trappola */
    var attuale = pallino.getAttribute('aria-pressed') === 'true';
    salva(attuale ? '' : pallino.getAttribute('data-sp-etui-valore'), contenitore, pallino.getAttribute('aria-label'));
  });
})();
